.card {
  // background: none;
  // background: linear-gradient(0deg, rgba(186, 207, 247, .04), rgba(186, 207, 247, .04)), rgba(5, 6, 15, .97);
  box-shadow: inset 0 1px 1px 0 rgba(216, 236, 248, .2), inset 0 24px 48px 0 rgba(168, 216, 245, .06), 0 16px 32px rgba(0, 0, 0, .3);
  background-clip: content-box;
  border-radius: 1rem;
  padding: 1px;
}

.card:after {
  --dot-color: #f3f3f3;
  --dot-size: 8px;
  content: "";
  position: absolute;
  inset: 16px;
  // inset: 216px 16px 16px 16px;
  pointer-events: none;
  filter: drop-shadow(0 0 8px rgb(233, 233, 233));
  background-image: radial-gradient(var(--dot-color) 50%, transparent 50%), radial-gradient(var(--dot-color) 50%, transparent 50%), radial-gradient(var(--dot-color) 50%, transparent 50%), radial-gradient(var(--dot-color) 50%, transparent 50%);
  background-size: var(--dot-size) var(--dot-size),
  var(--dot-size) var(--dot-size),
  var(--dot-size) var(--dot-size),
  var(--dot-size) var(--dot-size);
  background-position: 0 0, 100% 0, 0 100%, 100% 100%;
  background-repeat: no-repeat;
}
